export default {
  computed: {
    isAuth() {
      return (
        localStorage.getItem('authToken') != null &&
        localStorage.getItem('authToken') != ''
      );
    }
  },
  methods: {
    logout() {
      this.axiosRequest('post', 'Auth/Logout')
        .then(response => {
          //console.log(response.data);
        })
        .catch(function(error) {
          console.log(error.response.data.message);
        })
        .finally(() => {
          localStorage.removeItem('authToken');
          localStorage.removeItem('userID');
          this.$store.commit('setAuthToken', '');
          this.$store.commit('setUser', {});
          window.location.href = '/login';
        });
    }
  }
};
